<template>
  <div class="img-and-content-container">
    <div class="img-and-content-inner">
      <div class="text-box">
        <a-row :gutter="[24, 24]">
          <a-col v-for="(item, i) in eleConfig.dataList" :key="item._id" :span="6">
            <div class="block-title" :class="`title-${i%4}`">{{ $dt(item, 'title') }}</div>
            <div class="block-content" :class="`content-${i%4}`">{{ $dt(item, 'content') }}</div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialB",
  mixins: [componentMixin],
  computed: {}
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-color: white;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;

    .block-title {
      text-align: center;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      padding: 30px;
    }

    .title-0 {
      background-color: #d83479;
    }

    .title-1 {
      background-color: #5d9947;
    }

    .title-2 {
      background-color: #dda129;
    }

    .title-3 {
      background-color: #013d82;
    }

    .block-content {
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      height: 220px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 22px;
      font-weight: 600;
      text-align: center;
    }

    .content-0 {
      background-color: #f8dde8;
    }

    .content-1 {
      background-color: #e4ede0;
    }

    .content-2 {
      background-color: #f9efdb;
    }

    .content-3 {
      background-color: #d5dfea;
    }
  }
}
</style>
